var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" "+_vm._s(_vm.$t( "THIS_STEP_WILL_ONLY_BE_ACCESSIBLE_ONCE_THE_CONFIGURATION_STEP_HAS_BEEN_COMPLETED" ))+" "),_c('div',{staticClass:"flex justify-center mt-4"},[_c('b-button',{attrs:{"type":"is-primary","tag":"router-link","to":{
        name: 'facebookAction',
        params: Object.assign({}, _vm.$route.params, {tab: 'initialization'})
      }}},[_vm._v(" "+_vm._s(_vm.$t("INITIALIZATION"))+" ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }